import { toast } from 'react-toastify';
import { ErrorGeneric } from '../theme/appConfig';
export const ErrorHandlingService = {
  handleError: (error, module, functionName, customErrorMsg) => {
    console.error('error', error, module, functionName, customErrorMsg);
    toast.error(
      customErrorMsg
        ? `${error}, ${customErrorMsg}`
        : `${error}, ${ErrorGeneric.defaultMsg}`,
    );
  },
};
